<template>
    <div class="login">
    <div class="content">
        <a-form
    :model="formState"
    name="basic"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 19 }"
    autocomplete="off"
    @finish="onFinish"
    @finishFailed="onFinishFailed"
  >
    <a-form-item
      label="账号"
      name="username" 
      :rules="[{ required: true, message: '请输入预留的手机号码!' }]"
    >
      <a-input v-model:value="formState.username" placeholder="请输入预留的手机号码" />
    </a-form-item>

    <a-form-item
      label="密码"
      name="password"
      :rules="[{ required: true, message: '请输入密码!' }]"
    >
      <a-input-password v-model:value="formState.password"  placeholder="请输入预留的密码" />
    </a-form-item>

    <!-- <a-form-item name="remember" :wrapper-col="{ offset: 4, span: 19 }">
      <a-checkbox v-model:checked="formState.remember">记住我</a-checkbox>
    </a-form-item> -->

    <a-form-item :wrapper-col="{ offset: 10, span: 12 }">
      <a-button type="primary" html-type="submit">登陆</a-button>
    </a-form-item>
  </a-form>

    </div>

    </div>
</template>

<script setup>

import {$login} from '../api/login'
import { reactive } from 'vue';
import md5 from'js-md5'
//导入路由器对象，useRouter跳转页面时需要使用
import { useRouter } from 'vue-router';
let $router=useRouter();

const formState = reactive({
  username: '',
  password: '',
  remember: false,
});
const onFinish = async (values) => {
  console.log('Success:', values);
  //从values里面获取参数，也可以从formState中获取
  let {username,password,remember}=values;
  //对密码进行加密
  //password=md5(md5(password).split('').reverse().join(''));
  console.log("原："+password);
  password=md5(password)
  console.log("后："+password);
  //调用login接口
  let code= await $login({"mobile":username,"passwd":password,"remember":formState.remember})
  console.log("code:"+code)
  if(code==='success'){
    console.log('登陆成功')
     //跳转到Layout.vue页面
     $router.push("/reservation")
  }else{
    console.log('登陆失败')
  }

};
const onFinishFailed = errorInfo => {
  console.log('Failed:', errorInfo);
};
</script>


<style lang="scss" scoped>
.login{
    width: 100vw;
    height: 100vh;
    background: linear-gradient(to bottom, rgb(5, 57, 79),rgb(200,235,250));
    display: flex;
    justify-content: center;
    align-items: center;
    //登录框的样式
    .content{
        padding: 20px;
        padding-bottom: 0px;
        width: 500px;
        height: 250px;
        border:1px solid #fff;
        border-radius:6px;
    }
}
</style>